import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "store/index";

const selectNetwork = (state: RootState) => state.network;

const selectNetworkQuality = createSelector(
  selectNetwork,
  (substate) => substate?.networkQuality,
);

const selectNetworkIsConnected = createSelector(
  selectNetwork,
  (substate) => substate?.isConnected,
);

const selectNetworkSpeed = createSelector(
  selectNetwork,
  (substate) => substate?.networkSpeed,
);

export {
  selectNetwork,
  selectNetworkQuality,
  selectNetworkIsConnected,
  selectNetworkSpeed,
};
